/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
export const isUndefined = (value: any): value is undefined => typeof value === "undefined";
